// import { ArrowIcon } from "../../../../assets/icons/Cards/ArrowIcon";
import { InfoIcon } from "../../../../assets/icons/Cards/InfoIcon";
// import { RouterIcon } from "../../../../assets/icons/Cards/RouterIcon";
// import { ToolIcon } from "../../../../assets/icons/Cards/ToolIcon";
import {
  PrimaryCard,
  CardContent,
  CardStyled,
  InfoIconStyled,
  FooterContainer,
} from "../../../../styles/Screens/CarouselStyled";
import { T } from "../../../../styles/Theme";
import { Button } from "../../../Button";
import { SecondDescription } from "./SecondDescription";
import { useContext, useEffect, useState } from "react";
import { Tooltip } from "../../../Tooltip";
import { CheckOrange } from "../../../../assets/icons/CheckOrange";
import { SelectedServiceGTM } from "../../../../utils/GoogleTagManager";
import { AnswersContext } from "../../../../contexts/AnswersContext";
import { HeartIcon } from "../../../../assets/icons/HeartIcon";
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from "../../../../utils/common";
import { DataContext } from "../../../../contexts/DataContext";
import { parseQuestionsAndAnswers } from "../../../../utils/openai";
import axios from "axios";
import TypingEffect from "../../../TypingEffect";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ChatIcon } from "../../../../assets/icons/ChatIcon";
import ThreeDots from "../../../ThreeDots";
import { CHAT_BETA_URL } from "../../../../env";

interface ICardSlide {
  data: any;
  onSelectService: any;
}

export const CardSlide = ({ data, onSelectService }: ICardSlide) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [answers, ] = useContext(AnswersContext);
  const [finalForm, ] = useContext(DataContext);
  const [chat, setChat] = useState("");

  const pricingArr = data.pricing[0].includes("Contratando") ? data.pricing[0].split(",") : data.pricing[0].split("+");

  useEffect(() => {
    const config = {
      headers: {"Content-Type": "application/json",}
    };
    const bodyTest = JSON.stringify({
      data: parseQuestionsAndAnswers(finalForm),
      product: data.name,
      type: 4,
      number_of_characters: 150,
      emoji: true
    })
    axios.post(`${CHAT_BETA_URL}/predict/`, bodyTest, config)
      .then(response => {
        setChat(response.data.result);
      });
  }, []);

  return (
    <CardStyled>
      <PrimaryCard>
        {tooltipOpen && (
          <Tooltip handleClose={() => setTooltipOpen(false)}>
            <SecondDescription brk data={data} />
          </Tooltip>
        )}
        {data.use && (
          <InfoIconStyled onClick={() => setTooltipOpen(!tooltipOpen)}>
            <InfoIcon />
          </InfoIconStyled>
        )}

        <p className="internet">{data.name}</p>

        <ul>
          {data.description.map((el: any, i: number) => {
            return (
              <li className="down_arrow" key={i}>
                <div className="icon">
                  <CheckOrange />
                </div>
                <p>{el}</p>
              </li>
            );
          })}
        </ul>

        <p className="oferta">Oferta exclusiva web</p>

        {pricingArr[0].includes("Contratando") ? (
          <>
            <div className="precio">
              <p className="number">{pricingArr[1]?.split("+")[0]}</p>
              <p className="iva">{"+" + pricingArr[1]?.split("+")[1]}</p>
            </div>
            <p className="doce_meses">{pricingArr[0]}</p>
          </>
        ) : (
          <>
            <div className="precio">
              <p className="number">{pricingArr[0]}</p>
              <p className="iva">+IVA / mes</p>
            </div>
            <p className="doce_meses">{data.pricing[1]}</p>
          </>
        )}
      </PrimaryCard>
      <CardContent>
        <div className="match"><HeartIcon className="iconSvg"/> Match:100%</div>

        {data.use && (
          <div className="description2">
            <SecondDescription data={data} />
          </div>
        )}

        <div className="buttonContainer">
          <Button
            bg={T.blue}
            c="white"
            onClick={() => {
              window.open(data?.links[0].link);
              onSelectService();
              SelectedServiceGTM(window, getPlanSelected(finalForm), answers.email, answers.phone, getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm));
            }}
          >
            Quiero contratar
          </Button>
        </div>
      </CardContent>
      <FooterContainer>
        {(chat !== "") ? (
          <div className="footerContent">
            <ChatIcon/><TypingEffect text={chat} />
          </div>)
          : (
            <>
              <div className="footerContent"><ChatIcon/><ThreeDots /></div>
            </>
          )}
      </FooterContainer>
    </CardStyled>
  );
};
